module.exports = __webpack_public_path__ + "static/media/i-desktop.8ab456c6.png";